import { Page } from '../../../../components/page/page';
import { HasAccess } from '../../../../features/has-access/has-access';
import { TasksCreatePlannerModal } from './tasks-create-planner-modal/tasks-create-planner-modal';
import { TasksPlannerCards } from './tasks-planner-cards/tasks-planner-cards';
import { TasksPlannerControls } from './tasks-planner-controls/tasks-planner-controls';
import { TasksPlannerTable } from './tasks-planner-table/tasks-planner-table';
import s from './tasks-planner.module.css';
import { useTaskPlanner } from './use-task-planner';

export const TasksPlanner = () => {
  const {
    t,
    viewStyle,
    pagination,
    isOpenCreateScheduleModal,
    handleCloseCreateScheduleModal,
    handleOpenCreateScheduleModal,
    handleEnd,
  } = useTaskPlanner();

  return (
    <Page className={s.page}>
      <div className={s.header}>
        <h2>
          {t('Планировщик')} {pagination?.count ? `(${pagination.count})` : ''}
        </h2>

        <TasksPlannerControls onCreateClick={() => handleOpenCreateScheduleModal()} />
      </div>

      {viewStyle === 'table' ? <TasksPlannerTable /> : <TasksPlannerCards onEnd={handleEnd} />}

      <HasAccess service="task" permissions={['write']}>
        {isOpenCreateScheduleModal && (
          <TasksCreatePlannerModal onClose={() => handleCloseCreateScheduleModal()} />
        )}
      </HasAccess>
    </Page>
  );
};
